import FullscreenLoader from "@/components/fullscreen-loader";
import ResetPassword from "@/pages/reset-password";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useSession } from "@wacht/tanstack-router";

export const Route = createFileRoute("/reset-password")({
  component: RouteComponent,
});

function RouteComponent() {
  const { loading, session } = useSession();

  if (loading) {
    return <FullscreenLoader />;
  }

  if (session.active_signin) {
    return <Navigate to="/dashboard" />;
  }

  return <ResetPassword />;
}
